import { defineSlotRecipe } from "@chakra-ui/react/styled-system";
import { switchAnatomy } from "@chakra-ui/react/anatomy";

export default defineSlotRecipe({
  slots: switchAnatomy.keys(),
  variants: {
    variant: {
      solid: {
        control: {
          bg: "bg.muted",
        },
      },
    },
  },
  defaultVariants: {
    variant: "solid",
  },
});
